import {
  sagaListSuccess,
  sagaOneSuccess,
  sagaUpdateSuccess,
  sagaCreateSuccess
} from "../actions/ActionTypes";
import { remove } from "lodash";

const NOTICE_CATEGORIES = "notice_categories";
const NOTICE_CATEGORY = "notice_category";
const initialState = { list: [], currentNoticeCategory: {} };
const sorter = (a, b) => new Date(a.created_at) > new Date(b.created_at);

export default function noticeCategories(state = initialState, action = {}) {
  switch (action.type) {
    case "NEW_NOTICE_CATEGORY":
      return {
        ...state,
        currentNoticeCategory: {}
      };
    case "EDIT_NOTICE_CATEGORY":
      return {
        ...state,
        currentNoticeCategory: action.data
      };
    case sagaListSuccess(NOTICE_CATEGORIES):
      let list = action.data.data.sort(sorter);
      return { ...state, list };
    case sagaOneSuccess(NOTICE_CATEGORY):
      return { ...state, currentNoticeCategory: action.data.data };
    case sagaCreateSuccess(NOTICE_CATEGORY):
      state.list.push(action.data.data);
      state.list.sort(sorter);
      return { ...state, currentNoticeCategory: action.data.data };

    case sagaUpdateSuccess(NOTICE_CATEGORY):
      let updatedNoticeCategory = action.data.data;
      remove(state.list, x => x.id === updatedNoticeCategory.id);
      state.list.push(updatedNoticeCategory);
      state.list.sort(sorter);
      return { ...state, currentNoticeCategory: action.data.data };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/notice_categories.js